import { STORAGE_KEY } from "@/constant/export/storage";

const CLIENT_ID_PREFIX = import.meta.env.VITE_ABLY_CLIENT_ID_PREFIX ?? "hpoll-user";

const generateConversationId = () => {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `conv-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const buildAssistantClientId = (userId, conversationId) => {
    const safeUserId = (userId ?? "guest").toString().trim() || "guest";
    return `${CLIENT_ID_PREFIX}--${safeUserId}--${conversationId}`;
};

const resolveUserId = (userId) => {
    if (userId !== undefined && userId !== null && `${userId}`.trim() !== "") {
        return userId;
    }
    try {
        const storedUser = JSON.parse(localStorage.getItem(STORAGE_KEY.USER) || "{}");
        if (storedUser?.id !== undefined && storedUser?.id !== null) {
            return storedUser.id;
        }
    } catch {
    }
    return null;
};

const broadcastIdentityUpdate = (clientId, conversationId) => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
        new CustomEvent("assistant:identity-updated", {
            detail: { clientId, conversationId },
        }),
    );
};

export const ensureAssistantIdentity = ({
    userId,
    resetConversation = false,
    notify = false,
} = {}) => {
    let conversationId = resetConversation
        ? null
        : localStorage.getItem(STORAGE_KEY.AI_ASSISTANT_CONVERSATION_ID);
    if (!conversationId) {
        conversationId = generateConversationId();
    }
    const resolvedUserId = resolveUserId(userId);
    const clientId = buildAssistantClientId(resolvedUserId, conversationId);
    localStorage.setItem(STORAGE_KEY.AI_ASSISTANT_WS_CLIENT_ID, clientId);
    localStorage.setItem(STORAGE_KEY.WS_CLIENT_ID, clientId);
    localStorage.setItem(STORAGE_KEY.AI_ASSISTANT_CONVERSATION_ID, conversationId);
    if (notify) {
        broadcastIdentityUpdate(clientId, conversationId);
    }
    return { clientId, conversationId };
};

export const getStoredAssistantIdentity = () => ({
    clientId: localStorage.getItem(STORAGE_KEY.AI_ASSISTANT_WS_CLIENT_ID),
    conversationId: localStorage.getItem(STORAGE_KEY.AI_ASSISTANT_CONVERSATION_ID),
});
